import React from "react";
import Chip from "@mui/material/Chip";
import "./BillingPackageStatusChip.scss";
import startCase from "lodash/startCase";
import classNames from "../../../helpers/classNames";

interface BillingPackageStatusChipInterface {
  status: string;
}

const BillingPackageStatusChip: React.FC<BillingPackageStatusChipInterface> = ({ status }) => {
  const modifiedStatus = status.replace(/ /g, "");
  const statusText = startCase(modifiedStatus);

  return (
    <Chip
      className={classNames("billingPackageStatus", modifiedStatus)}
      size="small"
      label={statusText}
    />
  );
};

export default BillingPackageStatusChip;
